import React, { Component } from "react";
import { Grid, Col, Row, Button } from "react-bootstrap";
import Card from "../../../components/Card/Card";
import _ from "lodash";
import Loading from "../../../views/Loading";
import JqxGrid, { jqx } from "jqwidgets-scripts/jqwidgets-react-tsx/jqxgrid";
import { dominio } from "../../../routes_backend/routes.jsx";
import Swal from "sweetalert2";

const myGrid = React.createRef();
const myGridValidar = React.createRef(); // Ref separado para el grid de Validar

class ValidarCalculo_Resistencias extends Component {
  constructor(props) {
    super(props);
    this.state = {
      message: "",
      isLoading: false,
      value_ot: "",
      data_ot: [],
      source_grid: "",
      columns: [
        {
          text: "F. Ensayo",
          datafield: "U_fechaEnsayo",
          width: "5%",
          cellsalign: "center",
          pinned: true,
        },
        {
          text: "F. Recepcion",
          datafield: "U_fechaRecepcion",
          width: "6%",
          cellsalign: "center",
          pinned: true,
        },
        {
          text: "F. Produccion",
          datafield: "U_fechaProduccion",
          width: "6%",
          cellsalign: "center",
          pinned: true,
        },
        {
          text: "Dias Edad",
          datafield: "U_diasEdad",
          width: "6%",
          cellsalign: "center",
          pinned: true,
        },
        {
          text: "#Boleta",
          datafield: "U_boleta",
          width: "5%",
          cellsalign: "center",
          pinned: true,
        },
        { text: "Planta",     datafield: "U_planta",      width: "5%",  cellsalign: "center" },
        { text: "Molde",      datafield: "U_molde",       width: "8%",  cellsalign: "center" },
        { text: "Operador",   datafield: "U_operador",    width: "15%", cellsalign: "center" },
        { text: "U/M",        datafield: "U_um",          width: "5%",  cellsalign: "center" },
        { text: "Producto",   datafield: "U_producto",    width: "20%", cellsalign: "center" },
        { text: "Produccion", datafield: "U_produccion",  width: "6%",  cellsalign: "center" },
        {
          text: "OT",
          datafield: "U_ot",
          width: "12%",
          cellsalign: "center",
          editable: true,
          cellsrenderer: function (row, columnfield, value, defaulthtml, columnproperties) {
            return (
              '<div style="margin:4px; padding:4px; background-color:green; color:white; text-align:center; border-radius:4px;">' +
              value +
              "</div>"
            );
          },
        },
        { text: "Grosor Pared",          datafield: "U_grosorPared",  width: "6%",  cellsalign: "center" },
        { text: "Peso",                  datafield: "U_peso",         width: "5%",  cellsalign: "center" },
        { text: "KN",                    datafield: "U_kn",           width: "5%",  cellsalign: "center" },
        { text: "Ancho",                 datafield: "U_ancho",        width: "5%",  cellsalign: "center" },
        { text: "Alto",                  datafield: "U_alto",         width: "5%",  cellsalign: "center" },
        { text: "Largo",                 datafield: "U_largo",        width: "5%",  cellsalign: "center" },
        { text: "KN/KG",                 datafield: "U_KNKG",         width: "5%",  cellsalign: "center" },
        { text: "F1",                    datafield: "U_N1",           width: "5%",  cellsalign: "center" },
        { text: "F2",                    datafield: "U_N2",           width: "5%",  cellsalign: "center" },
        { text: "TipoForm",              datafield: "U_tipoFormula",  width: "5%",  cellsalign: "center" },
        { text: "A. Bruta (cm2)",        datafield: "U_ABruta",       width: "10%", cellsalign: "center" },
        { text: "Area bruta (Kg/Cm2)",   datafield: "U_SBruta1",      width: "10%", cellsalign: "center" },
        { text: "Rs Produccion",         datafield: "U_resisProd",    width: "10%", cellsalign: "center" },
        { text: "% Resistencia",         datafield: "U_R1",           width: "10%", cellsalign: "center" },
        { text: "Area bruta (Kg/Cm2) Promedio", datafield: "U_SBrutaProm", width: "15%", cellsalign: "center" },
        { text: "%R Promedio",           datafield: "U_RProm",        width: "10%", cellsalign: "center" },
      ],

      columnsValidar: [
        {
          text: "Validar",
          datafield: "Validar",
          width: "6%",
          columntype: "button",
          pinned: true,
          buttonclick: (row) => {
            const dataRecord = myGridValidar.current.getrowdata(row);

            this.saveBtn(
              dataRecord.U_fechaProduccion,
              dataRecord.U_boleta,
              dataRecord.U_planta,
              dataRecord.U_molde,
              dataRecord.U_operador,
              dataRecord.U_um,
              dataRecord.U_producto,
              dataRecord.U_produccion,
              dataRecord.U_grosorPared,
              dataRecord.U_peso,
              dataRecord.U_SBrutaProm1,
              dataRecord.U_RProm1,
              dataRecord.U_SBrutaProm2,
              dataRecord.U_RProm2,
              // ── NUEVOS ──
              dataRecord.U_SBrutaProm3,
              dataRecord.U_RProm3,
              dataRecord.U_SBrutaPromTotal,
              dataRecord.U_RPromTotal
            );
          },
        },
        { text: "F. Produccion", datafield: "U_fechaProduccion", width: "10%", cellsalign: "center", pinned: true },
        { text: "#Boleta",       datafield: "U_boleta",          width: "10%", cellsalign: "center", pinned: true },
        { text: "Planta",        datafield: "U_planta",          width: "10%", cellsalign: "center" },
        { text: "Molde",         datafield: "U_molde",           width: "10%", cellsalign: "center" },
        { text: "Operador",      datafield: "U_operador",        width: "15%", cellsalign: "center" },
        { text: "U/M",           datafield: "U_um",              width: "8%",  cellsalign: "center" },
        { text: "Producto",      datafield: "U_producto",        width: "30%", cellsalign: "center" },
        { text: "Produccion",    datafield: "U_produccion",      width: "8%",  cellsalign: "center" },
        { text: "Grosor Pared",  datafield: "U_grosorPared",     width: "8%",  cellsalign: "center" },
        { text: "Peso",          datafield: "U_peso",            width: "8%",  cellsalign: "center" },
        // ── Par 1 (existente) ──
        { text: "Rs Area bruta Promedio 1st Dias",    datafield: "U_SBrutaProm1", width: "15%", cellsalign: "center" },
        { text: "% Resistencia Promedio 1st Dias",    datafield: "U_RProm1",      width: "15%", cellsalign: "center" },
        // ── Par 2 (existente) ──
        { text: "Rs Area bruta Promedio 2do Dias",    datafield: "U_SBrutaProm2", width: "15%", cellsalign: "center" },
        { text: "% Resistencia Promedio 2do Dias",    datafield: "U_RProm2",      width: "15%", cellsalign: "center" },
        // ── Par 3 (NUEVO - Prueba) ──
        { text: "Rs Area bruta Promedio 3er Dias",    datafield: "U_SBrutaProm3", width: "15%", cellsalign: "center" },
        { text: "% Resistencia Promedio 3er Dias",    datafield: "U_RProm3",      width: "15%", cellsalign: "center" },
        // ── Par Total (NUEVO) ──
        { text: "Rs Area bruta Promedio Total",       datafield: "U_SBrutaPromTotal", width: "15%", cellsalign: "center" },
        { text: "% Resistencia Promedio Total",       datafield: "U_RPromTotal",      width: "15%", cellsalign: "center" },
      ],
    };
  }

  onChange = (event) => {
    this.setState({
      [event.target.name]: event.target.value,
      value_ot: event.target.value,
    });
  };

  clear = () => {
    this.setState({
      message: "",
      value_ot: "",
      isLoading: false,
      data_ot: [],
      source_grid: null,
      source_grid_validar: null,
    });
  };

  // ── NUEVO: acepta los 4 parámetros adicionales ──
  saveBtn = (
    U_fechaProduccion,
    U_boleta,
    U_planta,
    U_molde,
    U_operador,
    U_um,
    U_producto,
    U_produccion,
    U_grosorPared,
    U_peso,
    U_SBrutaProm1,
    U_RProm1,
    U_SBrutaProm2,
    U_RProm2,
    U_SBrutaProm3,
    U_RProm3,
    U_SBrutaPromTotal,
    U_RPromTotal
  ) => {
    this.setState({ message: "", isLoading: true });

    let username = "";
    let password = "";

    const token = localStorage.getItem("token");
    const token_Data = JSON.parse(token);

    if (token_Data !== null) {
      token_Data.forEach((element) => {
        username = element.usuarioSAP;
        password = element.contraseñaSAP;
      });
    } else {
      this.props.history.push("");
      return;
    }

    fetch(`${dominio}/post_BoletaCalcResisBoleta`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        U_fechaProduccion,
        U_boleta,
        U_planta,
        U_molde,
        U_operador,
        U_um,
        U_producto,
        U_produccion,
        U_grosorPared,
        U_peso,
        U_SBrutaProm1,
        U_RProm1,
        U_SBrutaProm2,
        U_RProm2,
        // ── NUEVOS ──
        U_SBrutaProm3,
        U_RProm3,
        U_SBrutaPromTotal,
        U_RPromTotal,
        username,
        password,
      }),
    })
      .then(async (res) => {
        const data = await res.json();
        console.log(data);

        if (res.status === 409) {
          Swal.fire({
            icon: "warning",
            title: "Registro duplicado",
            text: data.message || "Ya existe un registro para esta boleta.",
          });
        } else if (res.ok && data.success) {
          Swal.fire({
            icon: "success",
            title: "Éxito",
            text: data.message || "Registro ingresado correctamente",
          }).then(() => {
            window.location.reload();
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "Error al insertar",
            text: data.message || "Error desconocido al guardar los datos.",
          });
        }

        this.setState({ isLoading: false, message: "" });
      })
      .catch((error) => {
        console.error("Error en la solicitud:", error);
        Swal.fire({
          icon: "error",
          title: "Error de red",
          text: error.message || "No se pudo conectar al servidor.",
        });
        this.setState({ isLoading: false });
      });
  };

  data = () => {
    const { value_ot } = this.state;

    this.setState({ source_grid: null });

    let username = "";
    let password = "";

    let token = localStorage.getItem("token");
    let token_Data = JSON.parse(token);

    if (token_Data !== null) {
      token_Data.forEach((element) => {
        username = element.usuarioSAP;
        password = element.contraseñaSAP;
      });
    }

    if (token_Data === null) {
      this.props.history.push("");
    }

    this.setState({ message: "", isLoading: true });

    let boleta = value_ot;

    fetch(`${dominio}/get_BoletaCalcResis`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ username, password, boleta }),
    })
      .then(async (res) => {
        let dataBoleta = await res.json();

        const temp_res = Object.entries(dataBoleta).length === 0;
        if (temp_res === true) {
          return this.setState({
            isLoading: false,
            message: "No data",
            source_grid: "",
          });
        }

        let source_Array = [];

        dataBoleta.forEach((element) => {
          let array = [
            element.U_fechaEnsayo,
            element.U_fechaRecepcion,
            element.U_fechaProduccion,
            element.U_diasEdad,
            element.U_boleta,
            element.U_planta,
            element.U_molde,
            element.U_operador,
            element.U_um,
            element.U_producto,
            element.U_produccion,
            element.U_ot,
            element.U_grosorPared,
            element.U_peso,
            element.U_kn,
            element.U_ancho,
            element.U_alto,
            element.U_largo,
            element.U_KNKG,
            element.U_N1,
            element.U_N2,
            element.U_tipoFormula,
            element.U_ABruta,
            element.U_SBruta1,
            element.U_resisProd,
            element.U_R1,
            element.U_SBrutaProm,
            element.U_RProm,
          ];
          source_Array.push(array);
        });

        let temp_source_grid = {
          localdata: source_Array,
          datafields: [
            { name: "U_fechaEnsayo",    type: "string", map: "0"  },
            { name: "U_fechaRecepcion", type: "string", map: "1"  },
            { name: "U_fechaProduccion",type: "string", map: "2"  },
            { name: "U_diasEdad",       type: "number", map: "3"  },
            { name: "U_boleta",         type: "number", map: "4"  },
            { name: "U_planta",         type: "string", map: "5"  },
            { name: "U_molde",          type: "string", map: "6"  },
            { name: "U_operador",       type: "string", map: "7"  },
            { name: "U_um",             type: "number", map: "8"  },
            { name: "U_producto",       type: "string", map: "9"  },
            { name: "U_produccion",     type: "number", map: "10" },
            { name: "U_ot",             type: "string", map: "11" },
            { name: "U_grosorPared",    type: "number", map: "12" },
            { name: "U_peso",           type: "number", map: "13" },
            { name: "U_kn",             type: "number", map: "14" },
            { name: "U_ancho",          type: "number", map: "15" },
            { name: "U_alto",           type: "number", map: "16" },
            { name: "U_largo",          type: "number", map: "17" },
            { name: "U_KNKG",           type: "number", map: "18" },
            { name: "U_N1",             type: "number", map: "19" },
            { name: "U_N2",             type: "number", map: "20" },
            { name: "U_tipoFormula",    type: "number", map: "21" },
            { name: "U_ABruta",         type: "number", map: "22" },
            { name: "U_SBruta1",        type: "number", map: "23" },
            { name: "U_resisProd",      type: "number", map: "24" },
            { name: "U_R1",             type: "number", map: "25" },
            { name: "U_SBrutaProm",     type: "number", map: "26" },
            { name: "U_RProm",          type: "number", map: "27" },
          ],
          datatype: "array",
        };

        this.setState({
          source_grid: new jqx.dataAdapter(temp_source_grid),
          isLoading: false,
          message: "",
        });

        this.dataValidar();
      })
      .catch((error) => {
        console.log(error);
        this.setState({ message: "error in server", isLoading: false });
      });
  };

  dataValidar = () => {
    const { value_ot } = this.state;

    this.setState({ source_grid_validar: null });

    let username = "";
    let password = "";

    let token = localStorage.getItem("token");
    let token_Data = JSON.parse(token);

    if (token_Data !== null) {
      token_Data.forEach((element) => {
        username = element.usuarioSAP;
        password = element.contraseñaSAP;
      });
    }

    if (token_Data === null) {
      this.props.history.push("");
    }

    this.setState({ message: "", isLoading: true });

    let boleta = value_ot;
    console.log(boleta);

    fetch(`${dominio}/get_BoletaCalcResisValidar`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ username, password, boleta }),
    })
      .then(async (res) => {
        let dataBoletaValidar = await res.json();
        console.log(dataBoletaValidar);

        const temp_res = Object.entries(dataBoletaValidar).length === 0;
        if (temp_res === true) {
          const tieneDataArriba = this.state.source_grid && this.state.source_grid !== "";
          if (tieneDataArriba) {
            Swal.fire({
              icon: "info",
              title: "OT incompleta",
              text: "Esta OT aún no está lista para validar porque no se ha ingresado la segunda medición de edad.",
            });
          }
          return this.setState({
            isLoading: false,
            message: "No data",
            source_grid_validar: "",
          });
        }

        let source_Array = [];

        dataBoletaValidar.forEach((element) => {
          // ── Calcular promedios totales en el frontend ──
          // Solo se promedian los valores que existan y sean numéricos
          const sBrutaVals = [
            element.U_SBrutaProm1,
            element.U_SBrutaProm2,
            element.U_SBrutaProm3,
          ].filter((v) => v != null && v !== "" && !isNaN(parseFloat(v)));

          const rVals = [
            element.U_RProm1,
            element.U_RProm2,
            element.U_RProm3,
          ].filter((v) => v != null && v !== "" && !isNaN(parseFloat(v)));

          const U_SBrutaPromTotal =
            sBrutaVals.length > 0
              ? parseFloat(
                  (
                    sBrutaVals.reduce((a, b) => a + parseFloat(b), 0) /
                    sBrutaVals.length
                  ).toFixed(2)
                )
              : 0;

          const U_RPromTotal =
            rVals.length > 0
              ? Math.round(
                  rVals.reduce((a, b) => a + parseFloat(b), 0) / rVals.length
                )
              : 0;

          let array = [
            "Validar",
            element.U_fechaProduccion,
            element.U_boleta,
            element.U_planta,
            element.U_molde,
            element.U_operador,
            element.U_um,
            element.U_producto,
            element.U_produccion,
            element.U_grosorPared,
            element.U_peso,
            element.U_SBrutaProm1,
            element.U_RProm1,
            element.U_SBrutaProm2,
            element.U_RProm2,
            // ── NUEVOS ──
            element.U_SBrutaProm3  ?? 0,
            element.U_RProm3       ?? 0,
            U_SBrutaPromTotal,
            U_RPromTotal,
          ];

          source_Array.push(array);
          console.log(source_Array);
        });

        let temp_source_grid_validar = {
          localdata: source_Array,
          datafields: [
            { name: "Validar",            type: "string", map: "0"  },
            { name: "U_fechaProduccion",  type: "string", map: "1"  },
            { name: "U_boleta",           type: "number", map: "2"  },
            { name: "U_planta",           type: "string", map: "3"  },
            { name: "U_molde",            type: "string", map: "4"  },
            { name: "U_operador",         type: "string", map: "5"  },
            { name: "U_um",               type: "number", map: "6"  },
            { name: "U_producto",         type: "string", map: "7"  },
            { name: "U_produccion",       type: "number", map: "8"  },
            { name: "U_grosorPared",      type: "number", map: "9"  },
            { name: "U_peso",             type: "number", map: "10" },
            { name: "U_SBrutaProm1",      type: "number", map: "11" },
            { name: "U_RProm1",           type: "number", map: "12" },
            { name: "U_SBrutaProm2",      type: "number", map: "13" },
            { name: "U_RProm2",           type: "number", map: "14" },
            // ── NUEVOS ──
            { name: "U_SBrutaProm3",      type: "number", map: "15" },
            { name: "U_RProm3",           type: "number", map: "16" },
            { name: "U_SBrutaPromTotal",  type: "number", map: "17" },
            { name: "U_RPromTotal",       type: "number", map: "18" },
          ],
          datatype: "array",
        };

        this.setState({
          source_grid_validar: new jqx.dataAdapter(temp_source_grid_validar),
          isLoading: false,
          message: "",
        });
      })
      .catch((error) => {
        console.log(error);
        this.setState({ message: "error in server", isLoading: false });
      });
  };

  render() {
    const { isLoading, message, value_ot } = this.state;

    return (
      <div className="content" style={{ textAlign: "center", alignItems: "center" }}>
        <Grid fluid>
          <Row>
            <Col md={12}>
              <Card
                title="Validar Mediciones de Resistencias"
                ctTableFullWidth
                ctTableResponsive
                content={
                  <div className="content">
                    <div className="row" style={style.row}>
                      <div className="col-sm-3">
                        <label className="input-sizer stacked_OT">
                          <input
                            placeholder=" Ingrese OT ..."
                            name="value_ot"
                            value={value_ot}
                            onChange={this.onChange}
                          />
                        </label>
                      </div>

                      <div className="col-sm-3">
                        <Button onClick={this.data} bsStyle="primary" bsSize="small" active>
                          Search
                        </Button>
                        &nbsp;
                        <Button onClick={this.clear} bsStyle="danger" bsSize="small" active>
                          Clear
                        </Button>
                        <p style={style.errorMessage}>{message}</p>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-sm-12" style={{ overflow: "auto" }}>
                        <br />
                        <br />

                        {/* Grid de detalle (todas las filas: 6 normal / 9 prueba) */}
                        {!_.isEmpty(this.state.source_grid) ? (
                          <div className="col-sm-12">
                            <JqxGrid
                              ref={myGrid}
                              width={"100%"}
                              autoheight={true}
                              columns={this.state.columns}
                              source={this.state.source_grid}
                            />
                            <br />
                            <br />
                          </div>
                        ) : (
                          ""
                        )}

                        <br />
                        <br />

                        {/* Grid de validación con promedios por período */}
                        {!_.isEmpty(this.state.source_grid_validar) ? (
                          <div className="col-sm-12">
                            <p style={{ color: "red", fontSize: "24px" }}>
                              <strong>Validar</strong>
                            </p>
                            <JqxGrid
                              ref={myGridValidar}
                              width={"100%"}
                              autoheight={true}
                              columns={this.state.columnsValidar}
                              source={this.state.source_grid_validar}
                            />
                            <br />
                            <br />
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  </div>
                }
              />
            </Col>
          </Row>
        </Grid>

        {isLoading && <Loading />}
      </div>
    );
  }
}

const style = {
  errorMessage: {
    fontWeight: "bold",
    fontSize: "12px",
    height: "10px",
    color: "red",
  },
  text: {
    textAlign: "center",
    backgroundColor: "#dddddd",
    border: "2px solid",
    color: "#000",
    fontSize: "14px",
    fontWeight: "bold",
  },
  ColorCell: {
    textAlign: "center",
    border: "2px solid",
    color: "#000",
    fontSize: "14px",
  },
  row: {
    display: "flex",
    alignItems: "center",
  },
};

export default ValidarCalculo_Resistencias;